import React from 'react';
import PropTypes from 'prop-types';
import {
  Button, Layout, Popconfirm, Space, Table, Typography,
} from 'antd';
import { PlusOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons';

import useBoardsIndex from './hooks/useBoardsIndex';
import BoardFormModal from './nested/BoardFormModal';

const BoardsIndex = ({ initialBoards = [] }) => {
  const {
    boards,
    isModalOpen,
    editingBoard,
    colorBgContainer,
    borderRadiusLG,
    contextHolder,
    handleCreate,
    handleEdit,
    handleDelete,
    handleModalSubmit,
    handleModalClose,
  } = useBoardsIndex({ initialBoards });

  const columns = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      width: 80,
    },
    {
      title: 'Назва',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Дії',
      key: 'actions',
      width: 120,
      render: (_, record) => (
        <Space>
          <Button
            icon={<EditOutlined />}
            size="small"
            onClick={() => handleEdit(record)}
          />
          <Popconfirm
            title="Видалити дошку?"
            description="Цю дію не можна скасувати."
            onConfirm={() => handleDelete(record)}
            okText="Так"
            cancelText="Ні"
          >
            <Button icon={<DeleteOutlined />} size="small" danger />
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return (
    <div className="container">
      {contextHolder}
      <Layout
        style={{
          padding: '24px 0',
          marginTop: 15,
          background: colorBgContainer,
          borderRadius: borderRadiusLG,
        }}
      >
        <Layout.Content style={{ padding: '0 48px' }}>
          <div
            style={{
              background: colorBgContainer,
              minHeight: 280,
              padding: 24,
              borderRadius: borderRadiusLG,
            }}
          >
            <Space style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 16 }}>
              <Typography.Title style={{ margin: 0 }}>Дошки</Typography.Title>
              <Button type="primary" icon={<PlusOutlined />} onClick={handleCreate}>
                Створити дошку
              </Button>
            </Space>
            <Table
              dataSource={boards}
              columns={columns}
              rowKey="id"
              pagination={{ pageSize: 20 }}
            />
            <BoardFormModal
              isOpen={isModalOpen}
              editingBoard={editingBoard}
              onSubmit={handleModalSubmit}
              onClose={handleModalClose}
            />
          </div>
        </Layout.Content>
      </Layout>
    </div>

  );
};

BoardsIndex.propTypes = {
  initialBoards: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
  })),
};

export default BoardsIndex;
